import { AppstoreOutlined, ArrowUpOutlined, TeamOutlined, WalletOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Typography } from "antd";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../../redux/store";

const { Title, Paragraph } = Typography;

export default function ResellerHomePage() {
  const { user } = useSelector((state: RootState) => state.auth);
  const isEsimReseller = Boolean(user?.isEsimReseller);
  const [iconFailed, setIconFailed] = useState(false);

  return (
    <div className="reseller-home">
      <div className="reseller-home__hero">
        <div className="reseller-home__copy">
          <div className="reseller-home__eyebrow">Teltrip B2B</div>
          <Title level={2} className="reseller-home__title">
            Welcome to Teltrip B2B.
          </Title>
          <Paragraph className="reseller-home__subtitle">
            Your Resellers Program hub for plans, top-ups, and client management.
          </Paragraph>
        </div>

        <div className="reseller-home__banner">
          <div className="reseller-home__badge">
            {!iconFailed ? (
              <img
                src="/teltrip-icon.png"
                alt="Teltrip"
                className="reseller-home__badge-icon"
                onError={() => setIconFailed(true)}
              />
            ) : (
              <div className="brand-mark">TT</div>
            )}
            <div>
              <div className="reseller-home__badge-title">Reseller Console</div>
              <div className="reseller-home__badge-subtitle">
                Everything you need to sell quickly.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="reseller-home__grid">
        {isEsimReseller ? (
          <>
            <Link to="/plans" className="reseller-home__tile">
              <AppstoreOutlined />
              <div>
                <div className="reseller-home__tile-title">Plans</div>
                <div className="reseller-home__tile-subtitle">Browse and sell</div>
              </div>
            </Link>

            <Link to="/topUpEsim" className="reseller-home__tile">
              <ArrowUpOutlined />
              <div>
                <div className="reseller-home__tile-title">Top up</div>
                <div className="reseller-home__tile-subtitle">Assign to active SIMs</div>
              </div>
            </Link>
          </>
        ) : (
          <Link to="/assign-sim-package" className="reseller-home__tile">
            <AppstoreOutlined />
            <div>
              <div className="reseller-home__tile-title">SIM Packages</div>
              <div className="reseller-home__tile-subtitle">Manage SIM stock</div>
            </div>
          </Link>
        )}

        <Link to="/balance" className="reseller-home__tile">
          <WalletOutlined />
          <div>
            <div className="reseller-home__tile-title">Transactions</div>
            <div className="reseller-home__tile-subtitle">Track balance, credits & debits</div>
          </div>
        </Link>

        {isEsimReseller && (
          <Link to="/clients" className="reseller-home__tile">
            <TeamOutlined />
            <div>
              <div className="reseller-home__tile-title">Clients</div>
              <div className="reseller-home__tile-subtitle">Manage your base</div>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
